// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2MFKt","colMin":"styles_colMin__2XPv7","colCheckbox":"styles_colCheckbox__BKgNK"};